const employees = [
  { id: "101", name: "Mohammed Hegab", position: "CEO & Founder" },
  {
    id: "102",
    name: "Elham Kayed",
    position: "CDO",
    profile_pic: "default_user_2.png"
  },
  { id: "103", name: "Maysa Amin", position: "COO" },
  { id: "104", name: "Mohanad Adel", position: "Software Team Lead" },
  { id: "105", name: "Abdel Rahman el genany", position: "Hardware Team Lead" },
  {
    id: "1",
    name: "Ahmed Adil",
    position: "misc"
  },
  {
    id: "2",
    name: "Ahmed Amin",
    position: "misc"
  },
  {
    id: "3",
    name: "Ahmed Mohamed",
    position: "misc"
  },
  {
    id: "5",
    name: "Ali Abder Gafoor",
    position: "misc"
  },
  {
    id: "6",
    name: "Baseem Ragab",
    position: "misc"
  },
  { id: "7", name: "Ronnie Adams", position: "misc" },
  { id: "8", name: "Norah Valdez", position: "misc" },
  { id: "9", name: "Ariella Malone", position: "misc" },
  { id: "10", name: "Jay Clark", position: "misc" },
  { id: "11", name: "Corinne Padilla", position: "misc" },
  { id: "12", name: "Roman Kirby", position: "misc" },
  { id: "13", name: "Karsyn Wade", position: "misc" },
  { id: "14", name: "Jose Watts", position: "misc" },
  { id: "15", name: "Adyson Newton", position: "misc" },
  { id: "16", name: "Jeremy Ball", position: "misc" },
  { id: "17", name: "Jacqueline Herrera", position: "misc" },
  { id: "18", name: "Richard Patton", position: "misc" },
  { id: "19", name: "Madeleine Maddox", position: "misc" },
  { id: "20", name: "Kinley Sanford", position: "misc" },
  { id: "21", name: "Kassidy Boyd", position: "misc" },
  { id: "22", name: "Ryland Bright", position: "misc" },
  { id: "23", name: "Kyson Griffin", position: "misc" },
  { id: "24", name: "Mylie Gross", position: "misc" },
  { id: "25", name: "Rafael Beard", position: "misc" }
];

export default employees;
